import { render, staticRenderFns } from "./locationModel.vue?vue&type=template&id=6f178a74&scoped=true"
import script from "./locationModel.vue?vue&type=script&lang=js"
export * from "./locationModel.vue?vue&type=script&lang=js"
import style0 from "./locationModel.vue?vue&type=style&index=0&id=6f178a74&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f178a74",
  null
  
)

export default component.exports